import type { TFunction } from 'i18next';

import { LANGUAGE_NAMES } from '../../../i18n/languages';
import type { LanguageNote } from '../domain/languageView';

export const languageNoteText = (t: TFunction, note: LanguageNote): string | null => {
  switch (note.kind) {
    case 'none':
      return null;
    case 'siteDefault':
      return t('account.language.siteDefault', 'Your site’s default language. Pick one to choose your own.');
    case 'notOffered':
      return t(
        'account.language.notOffered',
        'Your site doesn’t offer {{saved}} now, so you get {{shown}}. Your pick comes back if the site offers it again.',
        { saved: LANGUAGE_NAMES[note.saved], shown: LANGUAGE_NAMES[note.shown] },
      );
    case 'onlyOne':
      return t('account.language.onlyOne', '{{language}} is the only language your site offers.', { language: LANGUAGE_NAMES[note.language] });
  }
};
